export interface MessageModelData {
    _id?: number;
    _text?: string;
    _date?: string;
    _sender?: any;
}


export class MessageModel {
    id?: number;
    text?: string;
    date?: string;
    sender?: any;

    public static fromAPI(data: MessageModelData): MessageModel {
        return new MessageModel(data);
    }

    constructor({_id, _text, _date, _sender}: MessageModelData) {
        this.id = _id;
        this.text = _text;
        this.date = _date;
        this.sender = _sender;
    }

}
